import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
declare var $;

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss']
})
export class DatepickerComponent implements OnInit {

  @Input() public date : any;
  @Input() public error : string;
  //element: el id que tendrá el input de seleccion de fecha. TODO: cambiar la forma en que se obtiene este input, para no depender de jquery.
  @Input() public element : string;
  @Input() public minDate : string;
  @Input() public maxDate : string;
  //Por default el input permite la edicion. En este caso hay que el validar que el valor ingresado sea una fecha valida.
  @Input() public readonly : boolean = false; 
  //isActive: se utilizará para inactivar la selección de la fecha
  @Input() public isActive : boolean = true; 
  @Output() public callback:EventEmitter<string> = new EventEmitter;

  public now:string;
  private dateObject: any;

  constructor() {}

  public ngOnChanges(changes: SimpleChanges) {
        
    if(changes.isActive){
      if(changes.isActive.currentValue){
        this.initializeDatePicker();
      }else{
        this.removeDatePicker();
      }
    }

    if (changes.date ) {
      if(this.date){
        //Caso para cuando se asigno una fecha al input y hay que aplicarla en el datepicker
        this.setModel();
      }else{
        //Caso para cuando se quiere restablecer el input y el datepicker a los valores default
        this.clearDate()
      }
    }
  }

  public ngOnInit() {
    //IMPORTANTE: Cuando se carga el componente tine un timer que lo inicializa después de 200 ms (No esta claro por que lo crearon asi)
    //Por lo tanto si se quiere definir una fecha inicial, se debe realizar después de este tiempo, para que el calendario aplique esta fecha
    //TODO: Esta 'raro' esto del timer, arreglarlo y ponerlo bien :)
      setTimeout( () => {
        this.start();
      }, 200);
  }

  public clearDate(){
    //Esta función se utiliza para restablecer el valor del datepicker, el input se muestra en blanco
    //y el calendario abre en el día de hoy
    this.input().val('');
    //Para poder limpiar el valor seleccionado anteriormente en el datepicker tuye que hacer un remove y luego volver a inicializarlo
    //TODO: Utilizar un componente nativo de Angular
    this.removeDatePicker();
    this.start();
  }

  public setModel(){
      const dateSetModel = this.date.slice(0,10);
      let input = this.input();
      if(input.length > 0){
        input.val(dateSetModel).trigger('change');
        this.setValueToDatePicker(input, dateSetModel);
      }else{
        //Cuando se trata de asignar el valor de la fecha, desde que carga el componente padre
        //hay ocasiones donde el input no se puede obtener utilizando jquery, ya que aun no tiene el id que se asigna con Angular
        //el timmer es un hack para resolverlo, pero este componete en general se debe hacer utilizando unicamente funciones de Angular
        //y no mezclar con jquery
        setTimeout( () => {
          let input = this.input();
          this.setValueToDatePicker(input, dateSetModel);
        }, 200);
      }
  }

  private setValueToDatePicker(input: any, dateSetModel: string){
    input.val(dateSetModel).trigger('change');
    let datepicker = input.data('daterangepicker');
    if(this.isActive && datepicker){
      datepicker.setStartDate(dateSetModel);
      datepicker.setEndDate(dateSetModel);
    } 
  }

  private input(){
    //TODO: No utilizar jquery para hacer el selector de input. Utilizar funciones de Angular :)
    return $('#' + this.element);
  }

  public emit(){
    const fecha = this.input().val();
    this.callback.emit(fecha);
  }

  private start(){
    //Solo si esta activo el componente, inicializamos el datepicker
    if(this.isActive){
      this.initializeDatePicker();
    }
  }

  private initializeDatePicker(){
    let dateInput = this.input();
    this.dateObject = this.input().daterangepicker({
        singleDatePicker: true,
        showDropdowns: true,
        minDate: (this.minDate != 'now') ? this.minDate: this.now,
        autoUpdateInput: false,
        locale: {
          format: 'YYYY-MM-DD'
        }
    }, function(chosen_date) {
        //Esta función la agregue para poder asignar la fecha seleccionada al input
        //ya que el parámetro autoUpdateInput: false, hace que no se asigne el valor de forma automática
        //agregue este parámetro para que el input aparezca vacio cuando carga el componente
        dateInput.val(chosen_date.format('YYYY-MM-DD'));
      }
    );
    const that = this;
    this.input().on('apply.daterangepicker', function(ev, picker) {
      that.emit();
    });
  }

  private removeDatePicker(){
    let datepicker = this.input().data('daterangepicker');
    //Si el date picker esta inicializado y se marco como inactivo lo removemos.
    if(datepicker){
      this.input().data('daterangepicker').remove();
    }
  }

  private getCurrentDate(){
    const today = new Date();
    let dd = today.getDate();
    let finalDay = dd.toString();
    let mm = today.getMonth() + 1; //January is 0!
    let finalMonth = mm.toString();

    var yyyy = today.getFullYear();
    if (dd < 10) {
      finalDay = '0' + dd;
    } 
    if (mm < 10) {
      finalMonth = '0' + mm;
    } 
    return yyyy + '-' + finalMonth + '-' + finalDay;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/tools/datepicker/datepicker.component.ts